// Minimal EN/ES dictionary for web UI chrome (checklist content itself is translated server-side).
const STRINGS = {
  en: {
    dashboard: "Dashboard",
    daily_logs: "Daily Logs",
    equipment: "Equipment",
    checklists: "Checklists",
    checklist_records: "Checklist Records",
    parts: "Parts & Materials",
    consumption: "Consumption",
    stock: "Stock",
    health: "Health",
    daily_report: "Daily Report",
    daily_reports: "Daily Reports",
    calendar: "Calendar",
    documents: "Documents",
    job_site_pictures: "Job Site Pictures",
    master: "Master Admin",
    settings: "Settings",
    logout: "Log out",
    quick_actions: "Quick Actions",
    health: "Health",
    consumed_month: "Consumed this month",
    new_entry: "New Log Entry",
    save_entry: "Save Entry",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    export: "Export",
    import: "Import",
    add: "Add",
    search: "Search",
    all_shifts: "All Shifts",
    no_machine: "No machine selected",
    read_only: "Read-only — your account cannot make changes",
  },
  es: {
    dashboard: "Panel",
    daily_logs: "Registros diarios",
    equipment: "Equipos",
    checklists: "Listas de verificación",
    checklist_records: "Registros de listas",
    parts: "Piezas y materiales",
    consumption: "Consumo",
    stock: "Inventario",
    health: "Salud",
    daily_report: "Informe diario",
    daily_reports: "Informes diarios",
    calendar: "Calendario",
    documents: "Documentos",
    job_site_pictures: "Fotos del sitio",
    master: "Administrador maestro",
    settings: "Configuración",
    logout: "Cerrar sesión",
    quick_actions: "Acciones rápidas",
    health: "Salud",
    consumed_month: "Consumido este mes",
    new_entry: "Nuevo registro",
    save_entry: "Guardar registro",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    edit: "Editar",
    export: "Exportar",
    import: "Importar",
    add: "Agregar",
    search: "Buscar",
    all_shifts: "Todos los turnos",
    no_machine: "Ninguna máquina seleccionada",
    read_only: "Solo lectura — su cuenta no puede realizar cambios",
  },
};

export const translate = (lang, key) => STRINGS[lang]?.[key] || STRINGS.en[key] || key;
